import React from "react";
import { Globe } from "lucide-react";
import { LANGS, useI18n } from "@/lib/i18n";

export default function LangSwitcher({ className = "" }) {
  const { lang, setLang } = useI18n();
  return (
    <div className={`relative inline-flex items-center gap-1.5 ${className}`} data-testid="lang-switcher">
      <Globe className="w-4 h-4" aria-hidden="true" />
      <label htmlFor="velixa-lang" className="sr-only">Choose language</label>
      <select
        id="velixa-lang"
        data-testid="lang-select"
        value={lang}
        onChange={(e) => setLang(e.target.value)}
        aria-label="Choose language"
        className="bg-transparent text-current text-[13px] font-semibold border-0 focus:outline-none focus:ring-2 focus:ring-white/60 rounded-sm cursor-pointer"
      >
        {LANGS.map((l) => (
          <option key={l.code} value={l.code} className="text-ink">{l.label}</option>
        ))}
      </select>
    </div>
  );
}
